import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { CustomProductSpecDetail } from '../../../models';
import { TmsWebBaseEditCreateService } from '../../base';

@Injectable({
  providedIn: 'root',
})
export class CustomProductSpecDetailService extends TmsWebBaseEditCreateService<
  CustomProductSpecDetail,
  CustomProductSpecDetail
> {
  constructor() {
    super('CustomProductSpecDetail', $localize`Custom Product Spec`);
  }

  getForCustomProductSpecHeader(id: string): Observable<CustomProductSpecDetail[]> {
    return this.httpService.get<CustomProductSpecDetail[]>(`${this.apiUrl}/GetForCustomProductSpecHeader?id=${id}`);
  }
}
